import React, { Component } from "react";
import SignUpScreens from "./SignUpScreens/index";

interface RegisterState {
}

class Register extends Component<{}, RegisterState> {
    state = { };

 

    render() {
        return (
            <div className="signup-wrapper">
               <SignUpScreens/>
            </div>
        );
    }
}

export default Register;
